import React from "react";
import { Badge } from "../../../../../components/Badge";
import { BTN_GHOST, BTN_PRIMARY, CARD } from "../../../../../styles";

export function ErrorPanel({ erros, loading, onMarcarLido, onRemover }) {
  const novos = erros.filter((item) => !item.lido).length;

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 14,
        }}
      >
        <div>
          <div style={{ fontSize: 18, fontWeight: 900, color: "#FFF" }}>
            Problemas reportados
          </div>
          <div
            style={{
              color: "rgba(255,255,255,.56)",
              fontSize: 12,
              marginTop: 4,
            }}
          >
            Acompanhamento dos alertas enviados pelos alunos.
          </div>
        </div>
        {novos > 0 && <Badge color="#EF4444">{novos} novo(s)</Badge>}
      </div>

      {loading && (
        <div style={{ ...CARD, padding: 18, color: "#64748B", fontSize: 13 }}>
          Carregando problemas reportados...
        </div>
      )}

      {!loading && !erros.length && (
        <div style={{ ...CARD, padding: 18, color: "#64748B", fontSize: 13 }}>
          Nenhum problema reportado.
        </div>
      )}

      <div style={{ display: "grid", gap: 10 }}>
        {erros.map((erro) => (
          <div
            key={erro.id}
            style={{
              ...CARD,
              padding: 16,
              border: erro.lido ? "1px solid transparent" : "1px solid #FECACA",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 12,
                alignItems: "start",
              }}
            >
              <div>
                {!erro.lido && <Badge color="#EF4444">NOVO</Badge>}
                <div
                  style={{
                    marginTop: 8,
                    fontSize: 15,
                    fontWeight: 900,
                    color: "#17212B",
                  }}
                >
                  {erro.aula_titulo}
                </div>
                <div style={{ fontSize: 12, color: "#64748B", marginTop: 4 }}>
                  {erro.curso_nome} - {erro.modulo_nome}
                </div>
              </div>
              <div style={{ fontSize: 11, color: "#94A3B8", fontWeight: 700 }}>
                {erro.criado_em}
              </div>
            </div>
            <div
              style={{
                marginTop: 12,
                padding: 12,
                borderRadius: 12,
                background: "#F8FBFC",
                color: "#334155",
                fontSize: 13,
                lineHeight: 1.6,
              }}
            >
              {erro.descricao}
            </div>
            <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
              {!erro.lido && (
                <button
                  onClick={() => onMarcarLido(erro.id)}
                  style={BTN_PRIMARY}
                >
                  Marcar como lido
                </button>
              )}
              <button
                onClick={() => onRemover(erro.id)}
                style={BTN_GHOST}
              >
                Remover
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
